module.exports = __webpack_public_path__ + "media/standard_lot.c593b95e.svg";